<div class="save-apply-dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Confirm Action</h2>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <div class="warning-message">
      <p>
        You are about to apply <strong>"{{ data.snapshotName }}"</strong>. All
        unsaved changes will be lost unless you save them as a new snapshot.
      </p>
    </div>

    <form [formGroup]="snapshotForm" class="snapshot-form">
      <div class="form-section">
        <h3>New Snapshot Details:</h3>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Snapshot Name</mat-label>
          <input
            matInput
            formControlName="name"
            placeholder="Snapshot Name"
            autocomplete="off"
          />
          @if (snapshotForm.get("name")?.hasError("required")) {
            <mat-error> Snapshot name is required </mat-error>
          }
        </mat-form-field>

        <div class="comment-section">
          <label class="comment-label">Comment</label>
          <div class="comment-toolbar">
            <button type="button" class="toolbar-btn" title="Bold">
              <mat-icon>format_bold</mat-icon>
            </button>
            <button type="button" class="toolbar-btn" title="Italic">
              <mat-icon>format_italic</mat-icon>
            </button>
            <button type="button" class="toolbar-btn" title="Underline">
              <mat-icon>format_underlined</mat-icon>
            </button>
            <button type="button" class="toolbar-btn" title="Quote">
              <mat-icon>format_quote</mat-icon>
            </button>
            <button type="button" class="toolbar-btn" title="Link">
              <mat-icon>link</mat-icon>
            </button>
            <button type="button" class="toolbar-btn" title="Image">
              <mat-icon>image</mat-icon>
            </button>
            <button type="button" class="toolbar-btn" title="Horizontal Line">
              <mat-icon>horizontal_rule</mat-icon>
            </button>
            <button type="button" class="toolbar-btn" title="Bullet List">
              <mat-icon>format_list_bulleted</mat-icon>
            </button>
            <button type="button" class="toolbar-btn" title="Numbered List">
              <mat-icon>format_list_numbered</mat-icon>
            </button>
            <button type="button" class="toolbar-btn" title="Code">
              <mat-icon>code</mat-icon>
            </button>
          </div>
          <textarea
            formControlName="comment"
            class="comment-textarea"
            placeholder="Add your comment here"
            rows="4"
          >
          </textarea>
        </div>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-stroked-button (click)="onCancel()" class="cancel-btn">
      Cancel
    </button>

    <button
      mat-raised-button
      color="primary"
      (click)="onSaveAndApply()"
      [disabled]="!isFormValid"
      class="save-and-apply-btn"
    >
      Save Current & Apply Selected
    </button>
  </div>
</div>
